import { Component, Input, OnInit } from '@angular/core';
import { Payroll } from '@app/models/payroll/payroll.model';
import { TransactionsTable } from '@app/modules/payroll/services/tables/transactions-table/transactions.table';
import { AuthService } from '@app/services';

@Component({
    selector: 'app-transactions-table[payroll]',
    template: `<app-table
        [title]="'table.transactions.title' | translate"
        [table]="table"
        [showOffset]="false"
    ></app-table>`,
})
export class TransactionsTableComponent implements OnInit {
    @Input() payroll!: Payroll;
    table!: TransactionsTable;

    constructor(private auth: AuthService) {}

    ngOnInit(): void {
        this.table = new TransactionsTable(this.auth, this.payroll.id);
    }
}
